import { TipsMapType } from "@op/components/BubbleCommon";

export const keyOpinionsRisingTopicsStudio: TipsMapType = {
  en: 'Topics are ranked by period-over-period growth rate in mention, selecting the top 4 with the highest growth rate and a minimum volume of 20.',
  zh: '声量不少于20且环比增长率最高的四个话题。',
};